/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import Evaluate from '../Utilities/evaluate';

import callApi from '../Utilities/CallApi';

let Actions = {
    setAlert : (args) => {
        alert (args.message)
        Actions.logConsole({message: 'Logging to COnsole as well'})
    },
    logConsole : (args) => {
        console.log(args.message)
    },
    iterateAndEvaluate : (obj, parent_obj) => {
        // console.log('Obj to Evaluate : ', obj)
        // console.log('Against: ', parent_obj)
        let commands = ['--eval', '--path']
        Object.keys(obj).forEach(key => {
            if (typeof obj[key] === 'object') {
                Actions.iterateAndEvaluate(obj[key],parent_obj)
            } else if (typeof obj[key] === 'string') {
                let text = obj[key].split(" ")

                if (commands.includes(text[0])) {
                    obj[key] = Evaluate(parent_obj, obj[key])
                }
            }
        })
        return obj
    },
    getOutput : (eval_obj, scenario, state) => {
        let output = {...eval_obj.output[scenario]}

        let parent_obj = {...this.props.config}
        parent_obj.data_store = {...state}

        output = this.iterateAndEvaluate(output, parent_obj)

        console.log('The Output From Workflow : ', output)

        return output
    },
    cloneAndUpdate : (obj, key_path, value) => {
        const clone = require('rfdc')()
        let new_obj = clone(obj)

        let key = new_obj
        key_path.map((path, i) => {
            if (i === (key_path.length - 1)) {
                key[path] = value
            } else {
                key = key[path]
            }
        })

        return new_obj
    },
    httpRequest : (args) => {
        // let response = callApi(args).then((res) => res.data).catch(err => err)
        // return response

        return callApi(args)
    },
    httpRequests : (args) => {
        let list_of_calls = args.map(arg => callApi(arg))
        return Promise.all(list_of_calls)
    }
}

export default Actions